// extracted by mini-css-extract-plugin
export default {"headerNavLinksWrapper":"MenuMobile_headerNavLinksWrapper__o0ELl","headerLink":"MenuMobile_headerLink__W42Pu","btn":"MenuMobile_btn__fQQQt"};